import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { CMSFacade } from 'ish-core/facades/cms.facade';

@Component({
  selector: 'custom-content-page-selection',
  templateUrl: './content-page-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentPageSelectionComponent implements OnInit {
  isContentPage$: Observable<boolean>;
  constructor(private cmsFacade: CMSFacade) {}
  ngOnInit(): void {
    this.isContentPage$ = this.cmsFacade.isContentPage$();
  }
}
